module.exports = __webpack_public_path__ + "static/media/anon.ecb6dd77.png";